import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '../store';
import { fixUrl } from './FixContainer';

// The primary action above the list: fix the mistakes in these games, one after another.
export default function GamesRepairAcross(): React.ReactNode {
  const { games } = useAppSelector((state) => state.gamesReducer);
  const { params } = useAppSelector((state) => state.paramsReducer);
  const { selectionMode } = useAppSelector((state) => state.uiReducer);
  const first = useMemo(
    () => (games?.List ?? []).find((g) => g.LastEvaluation != null && (g.RepairMistakes ?? 1) > 0),
    [games],
  );

  if (selectionMode || first == null) {
    return null;
  }
  return (
    <div className="cm-repair-launch">
      <Link className="btn btn-primary cm-repair-launch-btn" to={fixUrl(first.Id, params)}>
        <FontAwesomeIcon icon={faWrench} className="me-2" />
        Fix mistakes
      </Link>
    </div>
  );
}
